import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'clfl-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent {
    public openCloudFlow4TransUrl() {
        window.open(environment.cloudFlow4TransUrl, '_blank');
    }

    public openCloudFlow4InvoiceUrl() {
        window.open(environment.cloudFlow4InvoiceUrl, '_blank');
    }
}
